module.exports = __webpack_public_path__ + "media/images/top_menu_icon/payment_account-c2e60a4dd96eb1a67d35b12a1cc785b7.png";